import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Tabs from 'components/Tabs/Tabs'

import ROUTES from 'constants/routes'

import AudioTab from './Tabs/Audio/Audio'
import QuestionBanksTab from './Tabs/QuestionBanks/QuestionBanks'

import './Assets.scss'

class Assets extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <>
                <Tabs
                    isVisibleBottomLine={false}
                    list={[
                        {
                            to: `${ROUTES.ASSETS.path}/audio`,
                            label: 'Audio',
                        },
                        {
                            to: `${ROUTES.ASSETS.path}/question-banks`,
                            label: 'Question banks',
                        },
                    ]}
                />

                <div className="divider"></div>

                <br />
                <br />

                <Switch>
                    <Route
                        exact
                        path={`${ROUTES.ASSETS.path}/audio`}
                        render={() => <AudioTab location={this.props.location} history={this.props.history} />}
                    />
                    <Route
                        exact
                        path={`${ROUTES.ASSETS.path}/question-banks`}
                        render={() => <QuestionBanksTab location={this.props.location} history={this.props.history} />}
                    />
                    <Redirect
                        from="*"
                        to={{
                            pathname: ROUTES.ERROR.path,
                            state: {
                                errorCode: 404,
                            },
                        }}
                    />
                </Switch>
            </>
        )
    }
}

export default Assets
